var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select',{ref:"daySelect",staticClass:"form-control",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onChanged()}}},_vm._l((_vm.dictionary.get('Days')),function(day,index){return _c('option',{key:'day_select_' + index,domProps:{"value":index}},[_vm._v(" "+_vm._s(day)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }